<div class="modal" id="header_create_newpopup" role="dialog" data-bs-keyboard="false" data-bs-backdrop="static" tabindex="0" aria-label="Header Popup">
  <!-- Modal content -->
<div class="modal-dialog">
  <div class="modal-content">
    <div class="modal-main-content student_decision_status_popup" tabindex="-1" #modalContent>
      <span class="close delete-close"><img src="/assets/images/close_circle.svg" id="popup_close" style="display:none"
          data-bs-dismiss="modal" alt="Close"></span>
      <span class="close delete-close"><img src="/assets/images/close_circle.svg" tabindex="0" aria-label="close" data-bs-dismiss="modal"
          id="close_decision_popup" alt="Close" ></span>

      <div>
        <div *ngIf="role == 'Student'">
          <div class="full-width mt-10 mb-10">
            <div class="center mt-0">
              <h1 class="modal-heading" tabindex="0" *ngIf="role == 'Student'">Create/Change Action Plan</h1>
              <h1 class="modal-heading" tabindex="0" *ngIf="role != 'Student'">Change Action Plan</h1>
            </div>
            <p>An Action Plan consists of all inputs in the Securities, Loans, Deposits and Treasury Management forms.
              You
              can test you Action Plan by running <b>“Forecast" Simulations</b>.
              You can create additional Action Plans to test the impact of different decisions. When you are ready, you will <b>Submit for Final Competition</b>.
              Before Submitting, be sure the Action Plan you want is the “active” set on the Action Plan Dashboard, noted as “Current Action Plan.”
              Check that you’ve adjusted your dividends and EPS in Treasury Inputs before submitting.</p>
          </div>
        </div>
        <div *ngIf="role == 'Student'">
          <div class="row">
            <label for="decision_set_name"><b>Create New Action Plan:</b></label>
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 remove_margin">
              <p id="decision-set-description">Enter a Name and click Create New. Your Action Plan will be based on your final Action Plan inputs in the preceding Quarter.</p>
            </div>
            <div class="col-lg-7 col-xs-12 remove_margin mt-20">
              <input aria-label="text" class="form-control" type="text" maxlength="25" name="decision_set_name"
                [(ngModel)]="decision_set_name" id="decision_set_name" aria-describedby="decision-set-description" />
                <div *ngIf="error_message" class="errormsg" role="alert">
                  {{error_message}}
                </div>
                <button type="button" class="button-style2 remove_margin_top mt-10 mb-20"
                [disabled]="check_if_submitted() || disable_button || check_presence(decision_set_name)"
                (click)="create_decision_set('create')"> Create New</button>
            </div>
            <label for="dup_decision_set_name"><b>Save Current As:</b></label>
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 remove_margin">
              <p id="dup-decision-set-description">Enter a Name and click Save Current As to create a new Action Plan for the current quarter based on the inputs of the currently active Action Plan. This allows you to leverage those inputs to make a new Action Plan.  You can make changes to that Action Plan and preserve both Plans.</p>
            </div>
            <div class="col-lg-7 col-xs-12 remove_margin mt-20">
              <input aria-label="text" class="form-control" type="text" maxlength="25" name="dup_decision_set_name"
                [(ngModel)]="dup_decision_set_name" id="dup_decision_set_name"
                aria-describedby="dup-decision-set-description" />
                <div *ngIf="duplicate_error_message" class="errormsg">
                  {{duplicate_error_message}}
                </div>
                <button type="button" class="button-style2 remove_margin mt-10 mb-20"
                [disabled]="check_presence(dup_decision_set_name) || disable_button"
                (click)="create_decision_set('update')"> Save Current As</button>
              </div>
          </div>
        </div>
        <div>
          <p class="mt-10"><b>NOTE:</b> Any saved Action Plan may be reopened from the Action Plan Dashboard. Click the edit icon next to “Current Action Plan” to save, add, or switch plans.</p>
        </div>
        <div *ngIf="decision_sets.length > 0">
          <div class="full-width mt-10">
            <h2 class="modal-heading mb-0">Switch to Existing Action Plan: <a href="javascript:void(0)"
                (click)="getDecisionStatus()"> (Refresh)</a></h2>
          </div>
          <ul class="aba-list">
            <li *ngFor="let decision_set of decision_sets ; let decision_set_index = index"><a href="javascript:void(0)"
                data-bs-dismiss="modal" (click)="fetch_current_decision(decision_set)">{{decision_set.name}}</a></li>
          </ul>
        </div>
        <div class="full-width mt-10 mb-10">
        <div class="team_details" *ngIf="(decision_sets.length == 0)&&(role != 'Student')">
          <label>No action plans available for selection. Select another team:</label>
          <select title="select" aria-label="title" class="form-control team_dd width-125" (change)="setTeam($event)">
            <option *ngFor="let team of all_teams ; let index = index" [selected]="team.id == current_team.id"
              [value]="team.id">{{team.name}}</option>
          </select>
        </div>
        <div class="return_to_simulation" *ngIf="role != 'Student'">
          <a href="javascript:void(0)" data-bs-dismiss="modal" (click)="simulationStatusPath()">[Return to Simulation
            Dashboard]</a>
        </div>
      </div>

      </div>

    </div>
    </div>
  </div>
</div>